const CHUNK_SIZE = 0x8000;

/**
 * btoa/atob só aceitam caracteres Latin-1 (0-255). Qualquer caractere fora dessa
 * faixa (emoji, aspas curvas, travessão, etc.) faz o btoa lançar InvalidCharacterError.
 * Os helpers abaixo passam pelo UTF-8 antes de codificar/decodificar.
 */
export const encodeBase64 = (value: string): string => {
    const bytes = new TextEncoder().encode(value);

    let binary = '';
    for (let i = 0; i < bytes.length; i += CHUNK_SIZE) {
        binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK_SIZE));
    }

    return btoa(binary);
}

export const decodeBase64 = (value: string): string => {
    const binary = atob(value);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));

    return new TextDecoder().decode(bytes);
}
